import { BaseSeriesTooltipHelper } from "../base/tooltip-helper";

export class SunburstTooltipHelper extends BaseSeriesTooltipHelper {
    constructor() {
        super(...arguments), this.markTooltipKeyCallback = datum => null == datum ? void 0 : datum[this.series.getDimensionField()[0]];
    }
}
//# sourceMappingURL=tooltip-helper.js.map
